import React, { useState, useEffect } from 'react';
import SingleSelectDropdown, { Option } from './singleSelectDropdown';
import { useFetchUniqueValuesQuery } from 'services/api/creativePreview';
import { FormStyle } from './style';
import MultiSelectDropdown from './multiSelectDropdown';
import { MultiValue } from 'react-select';
import { UUIDTypes } from 'uuid';
import { Spinner } from '@alphonsocode/kallos';
import useQuery from 'reusable/customHooks/useQuery';

// Define Filter type for the filters prop
interface Filter {
  label: string;
  key: string;
  path: string;
  source?: string;
}

interface FilterRowProps {
  filters: any;
  isFetchingFilters: any;
  rowId: any;
  onFilterChange: any;
  selectedFilter?: any;
  selectedValue?: any;
  availableFilters: any;
  setIsOpen: any;
  [key: string]: any; // Allow additional props including key
}

export default function FilterRow({
  filters,
  isFetchingFilters,
  rowId,
  onFilterChange,
  selectedFilter = null,
  selectedValue = null,
  availableFilters,
  setIsOpen,
}: FilterRowProps) {
  const [query, setQuery] = useQuery();
  const [selectedFilterState, setSelectedFilter] = useState<Option | null>(
    selectedFilter,
  );
  const [selectedValues, setSelectedValues] =
    useState<MultiValue<Option> | null>(selectedValue || null);
  const [isDisabled, setIsDisabled] = useState(true);
  const [fetchedValues, setFetchedValues] = useState<
    { label: string; value: string }[]
  >([]);
  const [localDefaultOptions, setLocalDefaultOptions] = useState<Option[]>([]);
  const {
    data: values = [],
    isFetching,
    isLoading,
  } = useFetchUniqueValuesQuery(
    {
      key: filters.find(e => e.label === selectedFilterState?.label)?.key,
      path: filters.find(e => e.label === selectedFilterState?.label)?.path,
      source:
        filters.find(e => e.label === selectedFilterState?.label)?.source ||
        'DB',
      testType: query.get('testTag') || '',
    },
    {
      skip: !selectedFilterState,
    },
  );

  useEffect(() => {
    setIsDisabled(!selectedFilterState);
  }, [selectedFilterState]);

  useEffect(() => {
    if (selectedFilterState) {
      onFilterChange(rowId, selectedFilterState, selectedValues);
    }
  }, [selectedFilterState, selectedValues]);

  useEffect(() => {
    if (selectedValues === null) {
      setSelectedValues(null);
    }
    setLocalDefaultOptions([]);
    setFetchedValues([]);
  }, [selectedFilterState]);

  useEffect(() => {
    if (!isFetching && values.length > 0) {
      const mapped = values.map(item => ({
        value: item.value,
        label: item.label,
      }));
      setFetchedValues(mapped);
      setLocalDefaultOptions(mapped);

      // Resolve labels for selectedValue
      if (selectedValue && selectedValue.length > 0) {
        const resolved = selectedValue.map(val => {
          const match = mapped.find(item => item.value === val.value);
          return match ? match : val;
        });
        setSelectedValues(resolved);
      }
    }
  }, [values, isFetching]);

  const loadOptions = async (inputValue: string) => {
    try {
      const filtered = filters.filter(
        item =>
          item.key !== 'testTag' &&
          item.key !== 'testId' &&
          item.label.toLowerCase().includes(inputValue.toLowerCase()),
      );
      return filtered.map(item => ({
        value: item.key,
        label: item.label,
      }));
    } catch (error) {
      console.error('Error loading options:', error);
      return [];
    }
  };

  const loadValues = async (inputValue: string) => {
    try {
      const filtered = fetchedValues.filter(item =>
        item.label.toLowerCase().includes(inputValue.toLowerCase()),
      );
      return filtered;
    } catch (error) {
      console.error('Error loading values:', error);
      return [];
    }
  };
  console.log('selectedFilter: ', selectedFilterState);
  const scrollRef = React.useRef<HTMLDivElement>(null);
  const handleScrollToBottom = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  };
  return (
    <FormStyle>
      <div className="container-fluid text-center control-panel">
        <div className="row first-row w-100">
          <div className="col-6" onClick={handleScrollToBottom}>
            <label className="heading">Filter</label>
            <SingleSelectDropdown
              placeholder={'Select...'}
              value={selectedFilterState}
              onChange={newFilter => {
                setSelectedFilter(newFilter);
                setSelectedValues(null);
              }}
              loadOptions={loadOptions}
              defaultOptions={availableFilters}
              isLoading={isFetchingFilters}
              setIsOpen={setIsOpen}
            />
          </div>
          <div className="col-6">
            <label className="heading">Value</label>
            {(isFetching || isLoading) &&
            selectedFilterState?.path?.includes('_id') ? (
              <Spinner />
            ) : (
              <MultiSelectDropdown
                defaultOptions={localDefaultOptions}
                placeholder={'Select...'}
                value={selectedValues}
                onChange={setSelectedValues}
                loadOptions={loadValues}
                disabled={isDisabled}
                isLoading={isFetching}
                setIsOpen={setIsOpen}
              />
            )}
          </div>
        </div>
      </div>
    </FormStyle>
  );
}
